<h2 mat-dialog-title>New Translation Code</h2>

<mat-dialog-content>
    <form class="form" [formGroup]="form">
        <mat-form-field appearance="fill">
            <mat-label>
                Translation Code
            </mat-label>
            
            <input 
                matInput
                type="text"
                formControlName="id">
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" *ngIf="form">Save</button> 
</mat-dialog-actions>